export default __webpack_public_path__ + "static/media/detail_mobile_13_5.481e39ab.jpg";